import { Order, OrderFinancialStatus, OrderFulfillmentStatus } from 'shopify-types'

import type { OrderFieldsFragment } from '../../__generated/storefront'
import { mapGQLMoneyToMoney } from '../../graphql'
import { mapGQLProductVariantToProductVariant } from '../../product/graphql'

export type GQLOrder = OrderFieldsFragment

export const mapGQLOrderToOrder = (order: GQLOrder): Order => ({
  ...order,
  financialStatus: order.financialStatus as OrderFinancialStatus,
  fulfillmentStatus: order.fulfillmentStatus as OrderFulfillmentStatus,
  totalPrice: mapGQLMoneyToMoney(order.totalPrice),
  points: order.points ? parseInt(order.points.value ?? 0) : 0,
  lineItems: order.lineItems.edges.map(lineItem => ({
    ...lineItem.node,
    variant: lineItem.node.variant
      ? mapGQLProductVariantToProductVariant(lineItem.node.variant)
      : undefined,
    originalTotalPrice: mapGQLMoneyToMoney(lineItem.node.originalTotalPrice),
    discountedTotalPrice: mapGQLMoneyToMoney(lineItem.node.discountedTotalPrice),
  })),
})
